/** @jsx dom */
import dom from 'magic-virtual-element';
import {Image} from '@viskan/deku-media';

const render = ({props}) => <Image {...props}/>;

export default {render};
